import { Controller } from "@hotwired/stimulus"

// Replie un contenu chargé dans une Turbo Frame (historique d'un champ).
export default class extends Controller {
  clear() {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return
    frame.removeAttribute("src")
    frame.innerHTML = ""
  }
}
